__turbopack_context__.v({
  "activeNav": "HeaderMenu-module-scss-module__tELZsq__activeNav",
  "button": "HeaderMenu-module-scss-module__tELZsq__button",
  "headerButton": "HeaderMenu-module-scss-module__tELZsq__headerButton",
  "headerButtonsWrapper": "HeaderMenu-module-scss-module__tELZsq__headerButtonsWrapper",
  "headerMobile": "HeaderMenu-module-scss-module__tELZsq__headerMobile",
  "iconMenu": "HeaderMenu-module-scss-module__tELZsq__iconMenu",
  "logo": "HeaderMenu-module-scss-module__tELZsq__logo",
  "nav": "HeaderMenu-module-scss-module__tELZsq__nav",
});
